import React from "react";
import { NavLink } from "react-router-dom";

export default function Appbar() {
  return (
    <div className="">
      <nav className="navbar navbar-expand-lg navbar-dark shadow-sm px-4 ps-lg-5 pe-lg-5 py-3 py-lg-0 ">
        <NavLink to={"/home"}>
          <h1 className="text-primary my-3 ms-lg-5 ps-lg-4">KAMBA</h1>
        </NavLink>

        <button
          className="navbar-toggler btn-primary"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
        >
          <span className="fa fa-bars text-primary"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <div className="navbar-nav ms-auto py-0 pe-4">
            {" "}
            <NavLink to={"/home"} className="nav-item nav-link nav-link1">
              Início
            </NavLink>
            <NavLink
              to={"/contar-nos"}
              className="nav-item nav-link nav-link1"
            >
              Contar
            </NavLink>
          </div>
        </div>
      </nav>
    </div>
  );
}
